import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

interface AboutTransportSectionProps {
  cityName?: string;
  stateName?: string;
}

export const AboutTransportSection = ({
  cityName,
}: AboutTransportSectionProps) => {
  return (
    <section className=" py-10 md:py-24 ">
      <div className="container">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center bg-white py-3 px-6 md:px-16 rounded-xl md:rounded-full shadow-lg mb-8">
            <h2
              className="text-2xl text-n-primary md:text-4xl lg:text-[52px] "
              style={{ fontFamily: "'Anton', sans-serif", lineHeight: "1.2em" }}
            >
              {cityName
                ? `Precisa transportar um veículo de ${cityName} ou para ${cityName}, para qualquer lugar do Brasil?`
                : "Precisa transportar um veículo para qualquer lugar do Brasil?"}
            </h2>
          </div>

          <div className="my-12">
            <ImageSvg
              src="cegonha-concept.svg"
              alt={
                cityName
                  ? `Precisa transportar um veículo de ${cityName} ou para ${cityName}, para qualquer lugar do Brasil?`
                  : "Precisa transportar um veículo para qualquer lugar do Brasil?"
              }
              className=" w-full lg:h-[540px] "
            />
          </div>

          <div className="grid md:gap-16 gap-4 md:grid-cols-2">
            <div className="text-left">
              <h3 className="text-3xl font-semibold text-n-primary">
                A Nacional GO é especialista no transporte de carros, motos e
                outros veículos, oferecendo um serviço ágil e confiável.
              </h3>
            </div>

            <div className="text-left text-n-text-dark md:text-lg">
              <p className="mb-4">
                Somos a primeira plataforma digital de transporte de veículos e
                contamos com uma rede de transportadores credenciados, opções de
                coleta e entrega em domicílio e um atendimento que se adapta às
                suas necessidades.
              </p>
              <p className="mb-6 ">
                Aqui você encontra informações sobre como funciona o transporte,
                valores e as principais rotas que atendemos.
              </p>
              <Link to="/fazer-cotacao">
                <Button id="btn-fazer-cotacao">
                  Fazer cotação <ArrowRight className="ml-2 " />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
